import { openConflictingModal, setItemsConflictingModal } from '@slices/conflictingModalSlice';
import { setConflictModalCallbacks } from '@helpers/conflictModalCallbacks';
import { Dispatch } from 'redux';
import type { AxfoodCartEntryStatusViewModel } from '@occ/api-client';

const showCartConflictingModal = (
  items: Array<AxfoodCartEntryStatusViewModel>,
  resolve: (value: any) => void,
  reject: (reason: any) => void,
  dispatch: Dispatch,
  reason?: string
) => {
  if (items?.length) {
    dispatch(setItemsConflictingModal(items));
    dispatch(openConflictingModal({ open: true, reason }));
    setConflictModalCallbacks(resolve, reject);
  } else {
    resolve('No conflicting items');
  }
};

export default showCartConflictingModal;
